import {
  IconButton,
  Modal,
  Paper,
  Tooltip,
  Box,
  Badge,
  Avatar,
  Typography,
  Button,
  TextField,
  Divider,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Checkbox,
  InputAdornment,
  Chip,
  Collapse,
  Autocomplete,
} from "@mui/material";
import { Stack, useTheme } from "@mui/system";
import Resizer from "react-image-file-resizer";
import useStyles from "./styles";
import api from "../../../../../../services/api";
import {
  AddAPhoto,
  CheckBox,
  CheckBoxOutlineBlank,
  Clear,
  Person,
  PersonOff,
  PersonOutlineOutlined,
  Search,
} from "@mui/icons-material";
import { useEffect, useMemo, useState } from "react";
import VirtualizedAutocomplete from "../../../../../../components/virtualization/virtualizedAutocomplete";
import DatagridComponent from "../../../../../../components/datagridComponent";
import { getClienteOptionLabel } from "../../../../../../components/grupoEconomico/helpers";
import { temErp } from "../../../../../../services/erpSistema";
export default function ModalEditUser({
  openModalEditUser,
  setOpenModalEditUser = () => {},
  selectedRow,
  setUserEdit = () => {},
  userEdit,
  idCliente,
  setSnackbar = () => {},
  setUserCliente = () => {},
  userCliente,
  permissoes,
  clientes = [],
  usersErp = [],
  gruposCliente = [],
}) {
  const [editModalPerfil, setEditModalPerfil] = useState(false);
  const [Null, setNull] = useState(false);
  const [codigoPermissao, setCodigoPermissao] = useState("");
  const [disableSaveButtom, setDisableSaveButtom] = useState(false);
  const [emailValido, setEmailValido] = useState(false);
  const [selectedCliente, setSelectedCliente] = useState([]);
  const [selectedGrupos, setSelectedGrupos] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [isClientesPermitidos, setIsClientesPermitidos] = useState(false);
  const theme = useTheme();
  const styles = useStyles(theme);
  // Vínculo com usuário e grupos de cliente: só a HubSoft tem (aparece se o
  // sistema tiver HubSoft, mesmo com outros ERPs).
  const temHubsoft = temErp("HUBSOFT");
  const icon = <CheckBoxOutlineBlank fontSize="small" />;
  const checkedIcon = <CheckBox fontSize="small" />;

  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  const sortedAndFilteredRows = useMemo(() => {
    if (!clientes) return [];

    // 1. Filtro de busca
    const search = searchTerm.toLowerCase();
    const filtered = clientes.filter((cliente) => {
      return (
        cliente?.nome?.toLowerCase().includes(search) ||
        cliente?.razaoSocial?.toLowerCase().includes(search) ||
        cliente?.nomeFantasia?.toLowerCase().includes(search) ||
        cliente?.cnpj?.includes(search) ||
        cliente.clienteErpId?.toLowerCase().includes(search)
      );
    });

    // 2. Mapeamos os IDs selecionados para busca rápida
    const selectedIds = new Set(selectedCliente?.map((c) => c.id) || []);

    // 3. Ordenação (Selecionados sempre no topo)
    return filtered.sort((a, b) => {
      const aSelected = selectedIds.has(a.id);
      const bSelected = selectedIds.has(b.id);

      if (aSelected && !bSelected) return -1;
      if (!aSelected && bSelected) return 1;
      return 0;
    });

    // Ao adicionar 'selectedCliente' aqui, a lista reordena a cada clique
  }, [clientes, searchTerm, selectedCliente]);

  const columns = [
    {
      field: "razaoSocial",
      headerName: "Cliente",
      flex: 1,
      renderCell: (params) => {
        return getClienteOptionLabel(params.row);
      },
    },
    // Você pode adicionar outras colunas aqui (CNPJ, etc)
  ];
  // Cria um mapa de ID -> Objeto para busca rápida
  const rowsMap = new Map(clientes.map((obj) => [obj.id, obj]));

  useEffect(() => {
    setUserEdit({
      id: selectedRow?.id,
      nome: selectedRow?.nome,
      sobrenome: selectedRow?.sobrenome,
      login: selectedRow?.login,
      email: selectedRow?.email,
      status: selectedRow?.status,
      foto: selectedRow?.foto,
      userErpId: selectedRow?.userErpId,
    });

    let permissao =
      Array.isArray(permissoes) &&
      permissoes?.filter(
        (permissao) => permissao?.id === selectedRow?.permissoes?.permissaoId,
      );
    setCodigoPermissao(
      (Array.isArray(permissao) && permissao[0]?.codigoPermissao) || "",
    );
    setSelectedGrupos(selectedRow?.gruposCliente);

    setSelectedCliente(
      selectedRow?.clientesPermitidos?.map((item) => ({
        id: item?.id,
      })) || [],
    );
  }, [selectedRow]);

  useEffect(() => {
    if (emailRegex.test(userEdit?.email)) {
      setEmailValido(true);
    } else {
      setEmailValido(false);
    }
  }, [userEdit?.email]);

  useEffect(() => {
    if (codigoPermissao === "ADM") {
      setIsClientesPermitidos(false);
    } else {
      setIsClientesPermitidos(true);
    }
  }, [codigoPermissao]);
  const getChipColor = (permissaoObj) => {
    if (permissaoObj?.codigoPermissao === "ADM")
      return "chip.main.waitingReview";
    return permissaoObj?.color || theme.palette.colors.gray.medium; // Retorna a cor do objeto ou vazio
  };
  const handleUpdateCliente = () => {
    if (!userEdit?.login || !emailValido) {
      setSnackbar({
        children: "Necessário informar login e e-mail",
        severity: "error",
      });
      setNull(true);
    } else {
      if (!isClientesPermitidos) {
        setSelectedCliente([]);
        setSelectedGrupos([]);
      }
      updateUserCliente();
    }
  };

  const updateUserCliente = async () => {
    setDisableSaveButtom(true);
    try {
      let permissaoSelect = permissoes.filter(
        (permissao) => permissao?.codigoPermissao === codigoPermissao,
      );

      const response = await api.post("/interno/editUser", {
        usuarioId: userEdit?.id,
        nome: userEdit?.nome,
        sobrenome: userEdit?.sobrenome,
        login: userEdit?.login,
        email: userEdit?.email,
        status: userEdit?.status,
        foto: userEdit?.foto,
        clienteId: idCliente,
        permissao: (Array.isArray(permissaoSelect) && {
          permissaoId: permissaoSelect[0]?.id || "",
          usuarioId: userEdit?.id,
        }) || {
          permissaoId: selectedRow?.permissoes?.permissaoId,
          usuarioId: userEdit?.id,
        },
        clientesPermitidos: isClientesPermitidos
          ? selectedCliente?.map((item) => item?.id) || []
          : [],
        userErpId: userEdit?.userErpId || null,
        gruposCliente: isClientesPermitidos ? selectedGrupos || [] : [],
      });
      setSnackbar({
        children: "Perfil atualizado com sucesso",
        severity: "success",
      });
      setEditModalPerfil(false);

      const userFilter = userCliente?.filter(
        (user) => user?.id === userEdit?.id,
      );
      let objetoUserClient = userFilter[0];

      objetoUserClient = {
        ...objetoUserClient,
        login: userEdit?.login,
        email: userEdit?.email,
        nome: userEdit?.nome,
        sobrenome: userEdit?.sobrenome,
        status: userEdit?.status,
        foto: userEdit?.foto,
        clientesPermitidos: isClientesPermitidos ? selectedCliente || [] : [],
        permissoes: (Array.isArray(permissaoSelect) && {
          permissaoId: permissaoSelect[0]?.id,
          usuarioId: userEdit?.id,
        }) || {
          permissaoId: selectedRow?.permissoes?.permissaoId,
          usuarioId: userEdit?.id,
        },
        userErpId: userEdit?.userErpId,
        countClientes: response?.data?.updateUsuario?.countClientes,
        gruposCliente: response?.data?.updateUsuario?.gruposCliente,
      };
      const newDataUserClient = userCliente?.filter(
        (user) => user?.id !== userEdit?.id,
      );
      newDataUserClient.push(objetoUserClient);
      setUserCliente(newDataUserClient);
      handleClose();
    } catch (error) {
      let dataError = error?.response?.data;

      if (dataError) {
        if (dataError === "Email já existente") {
          setSnackbar({
            children: "E-mail existente",
            severity: "error",
          });
        } else if (dataError === "Login já existente") {
          setSnackbar({
            children: "Login existente",
            severity: "error",
          });
        } else {
          setSnackbar({
            children: "Erro ao atualizar informações do perfil",
            severity: "error",
          });
        }
      } else {
        setSnackbar({
          children: "Erro ao atualizar informações do perfil",
          severity: "error",
        });
      }
    } finally {
      setDisableSaveButtom(false);
    }
  };

  const handleClose = () => {
    setOpenModalEditUser(false);
    setNull(false);

    setUserEdit({
      id: selectedRow?.id,
      nome: selectedRow?.nome,
      sobrenome: selectedRow?.sobrenome,
      login: selectedRow?.login,
      email: selectedRow?.email,
      status: selectedRow?.status,
      foto: selectedRow?.foto,
      userErpId: selectedRow?.userErpId,
      gruposCliente: selectedRow?.gruposCliente,
    });
    setSelectedGrupos(selectedRow?.gruposCliente || []);
    let permissao =
      Array.isArray(permissoes) &&
      permissoes?.filter(
        (permissao) => permissao?.id === selectedRow?.permissoes?.permissaoId,
      );
    setCodigoPermissao(
      (Array.isArray(permissao) && permissao[0]?.codigoPermissao) || "",
    );
    setSelectedCliente(
      selectedRow?.clientesPermitidos?.map((item) => ({
        id: item?.id,
      })) || [],
    );
    setSearchTerm("");
  };

  return (
    <Modal
      sx={styles.containerModal}
      open={openModalEditUser}
      onClose={handleClose}
    >
      <Paper sx={styles.container}>
        <Stack sx={styles.StackFoto}>
          <Box sx={styles.BoxAvatar}>
            <Badge
              overlap="circular"
              anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
              badgeContent={
                <Tooltip title={"adicionar imagem"}>
                  <IconButton
                    disabled={disableSaveButtom}
                    variant="outlined"
                    component="label"
                    color="primary"
                    sx={styles.containerIconButton}
                  >
                    <AddAPhoto />
                    <input
                      hidden
                      accept=".png, .jpg, .jpeg"
                      type="file"
                      onChange={(e) => {
                        const file = e.target.files[0];
                        if (file?.size < 1024 * 1000) {
                          Resizer.imageFileResizer(
                            file,
                            500,
                            500,
                            "JPEG",
                            80,
                            0,
                            (uri) => {
                              setUserEdit((prev) => ({ ...prev, foto: uri }));
                            },
                            "base64",
                            500,
                            500,
                          );
                          const fileReader = new FileReader();
                          fileReader.readAsDataURL(file);
                          fileReader.onload = () => {};
                          fileReader.onerror = (error) => {
                            console.error("Error:", error);
                          };
                        } else {
                          setSnackbar({
                            children: "Tamanho máximo 1MB",
                            severity: "error",
                          });
                        }
                      }}
                    />{" "}
                  </IconButton>
                </Tooltip>
              }
            >
              <Avatar
                src={userEdit?.foto}
                color="secondary"
                sx={styles.Avatar}
              />
            </Badge>
          </Box>
        </Stack>
        <Box sx={styles.boxAreaModalPerfil}>
          <Box sx={styles.boxAreaTituloModalPerfil}>
            <Typography
              sx={{ color: theme.palette.white.main }}
              variant="title"
            >
              Perfil
            </Typography>
          </Box>
          <Paper sx={styles.boxAreaConteudoModalPerfil}>
            <Stack spacing={1} direction="row" width={"100%"} marginTop={5}>
              <TextField
                variant="filled"
                label="Nome"
                size="small"
                value={userEdit?.nome}
                disabled={disableSaveButtom}
                sx={styles.TextField}
                onChange={(e) =>
                  setUserEdit((prev) => ({ ...prev, nome: e.target.value }))
                }
              />

              <TextField
                variant="filled"
                label="Sobrenome"
                size="small"
                value={userEdit?.sobrenome}
                disabled={disableSaveButtom}
                sx={styles.TextField}
                onChange={(e) =>
                  setUserEdit((prev) => ({
                    ...prev,
                    sobrenome: e.target.value,
                  }))
                }
              />
            </Stack>
            <Divider orientation="horizontal" sx={styles.divider} />
            <Stack spacing={1} direction="row" width={"100%"}>
              <TextField
                variant="filled"
                label="Login"
                size="small"
                value={userEdit?.login}
                disabled={disableSaveButtom}
                sx={styles.TextField}
                onChange={(e) =>
                  setUserEdit((prev) => ({
                    ...prev,
                    login: e.target.value,
                  }))
                }
                helperText={
                  !userEdit?.login && Null ? "Necessário informar um login" : ""
                }
                error={!userEdit?.login && Null}
              />

              <TextField
                variant="filled"
                label="E-mail"
                size="small"
                disabled={disableSaveButtom}
                value={userEdit?.email}
                sx={styles.TextField}
                onChange={(e) =>
                  setUserEdit((prev) => ({
                    ...prev,
                    email: e.target.value,
                  }))
                }
                helperText={
                  (!userEdit?.email || !emailValido) && Null
                    ? "E-mail válido"
                    : ""
                }
                error={(!userEdit?.email || !emailValido) && Null}
              />
            </Stack>
            <Divider orientation="horizontal" sx={styles.divider} />

            <Stack spacing={1} direction="row" sx={{ width: "100%" }}>
              <FormControl
                variant="filled"
                size="small"
                sx={styles.TextField}
                fullWidth
                disabled={disableSaveButtom}
              >
                <InputLabel>Status</InputLabel>
                <Select
                  labelId="demo-simple-select-label"
                  value={!userEdit?.status ? "DESATIVADO" : "ATIVO"}
                  onChange={(e) => {
                    setUserEdit((prev) => ({
                      ...prev,
                      status: e.target.value === "DESATIVADO" ? 0 : 1,
                    }));
                  }}
                  name="status"
                  color="primary"
                >
                  <MenuItem value={"ATIVO"}>
                    <Box sx={styles.boxStatusItem}>
                      <Person
                        sx={{ color: theme.palette.chip.colorText.success }}
                      />
                      <Typography>ATIVO</Typography>
                    </Box>
                  </MenuItem>
                  <MenuItem value={"DESATIVADO"}>
                    <Box sx={styles.boxStatusItem}>
                      <PersonOff
                        sx={{ color: theme.palette.chip.colorText.critical }}
                      />
                      <Typography>DESATIVADO</Typography>
                    </Box>
                  </MenuItem>
                </Select>
              </FormControl>
              <FormControl
                variant="filled"
                size="small"
                sx={styles.TextField}
                fullWidth
                disabled={disableSaveButtom}
              >
                <InputLabel>Permissão</InputLabel>
                <Select
                  labelId="demo-simple-select-label"
                  value={codigoPermissao}
                  label="Permissão"
                  onChange={(event) => {
                    setCodigoPermissao(event.target.value);
                  }}
                  name="status"
                  color="primary"
                  renderValue={(selected) => {
                    const pObj = permissoes.find(
                      (p) => p.codigoPermissao === selected,
                    );
                    return (
                      <Box sx={{ display: "flex", flexWrap: "wrap", gap: 0.5 }}>
                        <Chip
                          label={selected.toUpperCase()}
                          size="small"
                          sx={{
                            ...styles.chipPermissao,
                            backgroundColor: getChipColor(pObj),
                          }}
                        />
                      </Box>
                    );
                  }}
                >
                  {Array.isArray(permissoes) &&
                    permissoes.map((permissao) => (
                      <MenuItem
                        key={permissao.id}
                        value={permissao.codigoPermissao}
                        sx={styles.menuItemPermissao}
                      >
                        <Chip
                          label={permissao.codigoPermissao.toUpperCase()}
                          size="small"
                          sx={{
                            ...styles.chipMenuItemPermissao,
                            backgroundColor: getChipColor(permissao),
                          }}
                        />
                      </MenuItem>
                    ))}
                </Select>
              </FormControl>
            </Stack>
            <Divider orientation="horizontal" sx={styles.divider} />
            {temHubsoft && (
              <>
                <VirtualizedAutocomplete
                  size="small"
                  options={usersErp || []}
                  value={(usersErp || []).find(
                    (u) => u.id?.toString() === userEdit?.userErpId?.toString(),
                  )}
                  isOptionEqualToValue={(option, value) => option.id === value}
                  /*  getOptionLabel={(option) => option?.name || ""}   */
                  onChange={(event, value) => {
                    setUserEdit((prev) => ({
                      ...prev,
                      userErpId: value?.id,
                    }));
                  }}
                  sx={{ width: "100%" }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      size="small"
                      variant="filled"
                      label="Usuário HubSoft"
                      helperText="Somente HubSoft: vincula este usuário a um usuário da HubSoft."
                      sx={styles.TextField}
                    />
                  )}
                />
              </>
            )}
            <Stack spacing={1} direction="column" sx={{ width: "100%" }}>
              <Collapse in={isClientesPermitidos} timeout={400} unmountOnExit>
                <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "flex-end",
                      flexWrap: "wrap",
                      gap: 2,
                    }}
                  >
                    <Box sx={{ mt: 2 }}>
                      <Box
                        sx={{ display: "flex", gap: 0.5, alignItems: "center" }}
                      >
                        <PersonOutlineOutlined sx={{ fontSize: "22px" }} />
                        <Typography sx={{ fontWeight: "bold" }}>
                          Clientes permitidos
                        </Typography>
                      </Box>
                      <Typography
                        sx={{
                          fontWeight: "bold",
                          fontSize: "12px",
                          opacity: 0.5,
                        }}
                      >
                        Caso não selecione nenhum cliente, o usuário terá acesso
                        a todos os clientes.
                      </Typography>
                    </Box>

                    {/* Campo de Busca */}
                    <TextField
                      size="small"
                      variant="outlined"
                      placeholder="Buscar cliente."
                      value={searchTerm}
                      onChange={(e) => setSearchTerm(e.target.value)}
                      sx={{ minWidth: "300px" }}
                      InputProps={{
                        startAdornment: (
                          <InputAdornment position="start">
                            <Search fontSize="small" />
                          </InputAdornment>
                        ),
                        endAdornment: (
                          <InputAdornment position="end">
                            {searchTerm && (
                              <IconButton
                                size="small"
                                onClick={() => setSearchTerm("")}
                              >
                                <Clear fontSize="small" />
                              </IconButton>
                            )}
                          </InputAdornment>
                        ),
                      }}
                    />
                  </Box>
                  <Paper variant="outlined" sx={styles.paperDatagrid}>
                    <DatagridComponent
                      options={{
                        checkboxSelection: true,
                        onRowSelectionModelChange: (currentSelectionIds) => {
                          const previouslySelected = selectedCliente || [];
                          const visibleIds = sortedAndFilteredRows.map(
                            (c) => c.id,
                          );

                          const itemsNotVisible = previouslySelected.filter(
                            (item) => !visibleIds.includes(item.id),
                          );

                          const itemsNewlySelected = currentSelectionIds
                            ?.filter((id) => visibleIds.includes(id))
                            ?.map((id) => rowsMap.get(id))
                            ?.filter(Boolean);

                          setSelectedCliente([
                            ...itemsNotVisible,
                            ...itemsNewlySelected,
                          ]);
                        },
                        rowSelectionModel: selectedCliente?.map((c) => c?.id),
                        disableRowSelectionOnClick: true,
                      }}
                      rows={sortedAndFilteredRows}
                      columns={columns}
                    />
                  </Paper>
                  {temHubsoft && (
                    <Autocomplete
                      multiple
                      id="checkboxes-tags-demo"
                      options={gruposCliente || []}
                      value={selectedGrupos || []}
                      disableCloseOnSelect
                      limitTags={2}
                      getLimitTagsText={(more) => `+${more}`}
                      sx={{
                        width: "100%",
                        "& .MuiInputBase-root": {
                          flexWrap: "nowrap",
                          overflow: "hidden",
                          paddingRight: "40px !important",
                        },
                      }}
                      onChange={(event, newValue) => {
                        setSelectedGrupos(newValue);
                      }}
                      isOptionEqualToValue={(option, value) =>
                        String(option.id) === String(value.id)
                      }
                      getOptionLabel={(option) => option?.grupoName || ""}
                      renderTags={(value, getTagProps) => {
                        const numSelected = value.length;
                        const limit = 2;

                        return (
                          <div
                            style={{
                              display: "flex",
                              alignItems: "center",
                              gap: "4px",
                              overflow: "hidden",
                            }}
                          >
                            {value.slice(0, limit).map((option, index) => (
                              <Chip
                                {...getTagProps({ index })}
                                key={index}
                                label={option.grupoName}
                                size="small"
                                sx={{ maxWidth: "120px" }}
                              />
                            ))}

                            {numSelected > limit && (
                              /* Tooltip adicionado aqui */
                              <Tooltip
                                arrow
                                title={
                                  <div
                                    style={{
                                      display: "flex",
                                      flexDirection: "column",
                                      padding: "4px",
                                    }}
                                  >
                                    {value.map((option, i) => (
                                      <span
                                        key={i}
                                        style={{
                                          display: "block",
                                          fontSize: "12px",
                                        }}
                                      >
                                        • {option.grupoName}
                                      </span>
                                    ))}
                                  </div>
                                }
                              >
                                <span
                                  style={{
                                    fontSize: "12px",
                                    color: "gray",
                                    whiteSpace: "nowrap",
                                    cursor: "pointer", // Indica que é interagível
                                    fontWeight: 500,
                                  }}
                                >
                                  +{numSelected - limit} selecionados
                                </span>
                              </Tooltip>
                            )}
                          </div>
                        );
                      }}
                      renderOption={(props, option, { selected }) => {
                        const { key, ...optionProps } = props;
                        return (
                          <li key={key} {...optionProps}>
                            <Checkbox
                              icon={icon}
                              checkedIcon={checkedIcon}
                              style={{ marginRight: 8 }}
                              checked={selected}
                            />
                            {option?.grupoName}
                          </li>
                        );
                      }}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          variant="filled"
                          size="small"
                          label="Grupos de cliente da HubSoft"
                          helperText="Somente HubSoft: libera os clientes desses grupos."
                          sx={{
                            ...styles.TextField,
                            "& .MuiInputBase-input": {
                              minWidth: "20px !important",
                              width: "0px !important",
                              flexGrow: 1,
                            },
                          }}
                        />
                      )}
                    />
                  )}
                </Box>
              </Collapse>
            </Stack>
            <Box sx={styles.containerButtonSalvar}>
              <Button
                onClick={() => handleClose()}
                sx={{
                  ...styles.button,
                  color: theme.palette.text.main,
                }}
                variant="outlined"
                size="large"
                disabled={disableSaveButtom}
              >
                Cancelar
              </Button>
              <Button
                disabled={disableSaveButtom}
                onClick={handleUpdateCliente}
                variant="contained"
                size="large"
                sx={styles.button}
              >
                Salvar
              </Button>
            </Box>
          </Paper>
        </Box>
      </Paper>
    </Modal>
  );
}
